import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import ouibounce from 'ouibounce';

var ReactOuibounce = function (_React$Component) {
  _inherits(ReactOuibounce, _React$Component);

  function ReactOuibounce() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactOuibounce);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      open: false,
      handler: null
    }, _this.setupOuibounce = function () {
      var handlerRef = ouibounce(false, _extends({}, _this.props, {
        callback: function callback() {
          return _this.setState({
            open: true // open the modal,

          });
        }
      }));

      _this.setState({
        handler: handlerRef
      });
    }, _this.handleDismiss = function () {
      // disable the ouibounce when child modal
      // is closed
      if (_this.state.handler) {
        _this.state.handler.disable();
      }

      _this.setState({
        open: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactOuibounce.prototype.componentDidMount = function componentDidMount() {
    this.setupOuibounce();
  };

  ReactOuibounce.prototype.componentWillUnmount = function componentWillUnmount() {
    // disable the ouibounce on unmount
    if (this.state.handler) {
      this.state.handler.disable();
    }
  };

  ReactOuibounce.prototype.render = function render() {
    // can deal with only one child
    var childEl = React.Children.only(this.props.children);
    var childElWithModalState = React.cloneElement(childEl, {
      shouldDisplay: this.state.open,
      handleDismiss: this.handleDismiss
    });
    return childElWithModalState;
  };

  return ReactOuibounce;
}(React.Component);

process.env.NODE_ENV !== "production" ? ReactOuibounce.propTypes = {
  sensitivity: PropTypes.number,
  aggressive: PropTypes.bool,
  timer: PropTypes.number,
  delay: PropTypes.number,
  cookieExpire: PropTypes.number,
  cookieName: PropTypes.string,
  cookieDomain: PropTypes.string,
  sitewide: PropTypes.bool
} : void 0;
export default ReactOuibounce;